import React, { useState } from "react";
import ContainerPop from "../../../Pops/ContainerPop";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import ButtonClose from "../../../Pops/ButtonClose";
import { CircularProgress, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { setSuccess } from "../../../../Redux/AlertReducer";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { errorToaster } from "../../../../helper/toasterConfiguration";

const AddShopModal = ({
  show,
  handleClose,
  data,
  setData,
  update,
  selectedId, //our_service_id
  setShouldRefresh,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const formDataToSend = new FormData();

    for (const key in data) {
      if (!data[key]) {
        formDataToSend.append(key, 0);
      } else {
        formDataToSend.append(key, data[key]);
      }
    }
    formDataToSend.append("our_service_id", selectedId);

    try {
      const apiConfig = {
        url: update
          ? api_Routes.Type.Edit + `/${data?.id}`
          : api_Routes.Type.Add, // Select endpoint
        data: formDataToSend,
      };

      const { result, response, message } = update
        ? await Helper.Put(apiConfig)
        : await Helper.Post(apiConfig);

      if (response) {
        setShouldRefresh((prev) => prev + 1);
        setData({ type: "", price: "", days: "", countTicket: "" });
        dispatch(setSuccess(true));
        handleClose();
      } else {
        errorToaster("Failed to add type");
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      errorToaster("Failed to add type");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`fixed inset-0 !z-50 ${
        show ? "visible" : "hidden"
      } bg-black bg-opacity-50 flex justify-center items-center`}
      onClick={handleClose}
    >
      <ContainerPop>
        <div
          aria-label="pop delete"
          className="swals-show flex justify-center relative box-border flex-col z-50 w-[32em] max-w-full p-4 border-0 rounded-sm bg-secondary dark:bg-darkPrimary text-textColor dark:text-darkTextColor m-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div aria-label="header" className="text-[1rem]">
            <div
              className="close absolute top-6 right-4 z-50 !cursor-pointer text-textColor dark:text-darkTextColor"
              onClick={handleClose}
            >
              <IoMdCloseCircleOutline size={"1.3rem"} />{" "}
            </div>
            <div className="relative flex justify-center items-center font-bold text-[#6c757d] text-3xl text-center mb-4">
              {update ? "Update Type" : "Add Type"}
            </div>
            <div className="block text-[#6c757d] font-semibold">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col gap-4">
                  <TextField
                    id="type"
                    name="type"
                    label="Type"
                    variant="outlined"
                    required
                    autoComplete="off"
                    fullWidth
                    value={data?.type}
                    onChange={handleInputChange}
                  />
                  <TextField
                    id="price"
                    name="price"
                    label="Price"
                    type="number"
                    variant="outlined"
                    required
                    fullWidth
                    value={data?.price}
                    onChange={handleInputChange}
                  />
                  <TextField
                    id="order"
                    name="order"
                    label="Order"
                    type="number"
                    variant="outlined"
                    required
                    fullWidth
                    value={data?.order}
                    onChange={handleInputChange}
                  />
                  <TextField
                    id="days"
                    name="days"
                    label="days"
                    type="number"
                    variant="outlined"
                    required
                    fullWidth
                    value={data?.days}
                    onChange={handleInputChange}
                  />
                  {selectedId !== 1 &&
                    selectedId !== 9 &&
                    selectedId !== 10 &&
                    selectedId !== 11 &&
                    selectedId !== 12 &&
                    selectedId !== 28 && (
                      <TextField
                        id="countTicket"
                        name="countTicket"
                        label="Count ticket"
                        type="number"
                        variant="outlined"
                        required
                        fullWidth
                        value={data?.countTicket}
                        onChange={handleInputChange}
                      />
                    )}
                </div>
                <div className="w-full mt-3 flex items-center justify-center flex-wrap">
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isLoading}
                    className="bg-primary m-1 py-2 px-8 font-medium text-[1.0625em] rounded-[0.25em] text-darkTextColor flex justify-center w-44"
                  >
                    {isLoading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      "Submit"
                    )}
                  </button>
                  <ButtonClose onClick={() => handleClose()} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </ContainerPop>
    </div>
  );
};

export default AddShopModal;
